import React from "react";
import { CardsItemProps } from "..";
import "./_styles.scss";
import { UserPermissions } from "../../../../../src/definitions";
import {  securityService } from "../../../../../src/_global/services";

export default function LibCard({ data }: CardsItemProps) {
  const { name = "", network } = data;

  return (
    securityService.checkRoleAccess(UserPermissions.viewCards)?
    (
    <div className="card">
      <div className="name">{`${name}`}</div>
      <div className="desc">{`${network?.name ?? ""}`}</div>
    </div>
    ): (<div></div>)
  );
}
